import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import SelectList from "app/Components/Shared/SelectList/SelectList";
import BtnSubmit from "app/Components/Shared/Buttons/BtnSubmit";
import { Onboarding } from "app/Components/Page/SelfCarePage/SelfCareAsyncThunk";
import {showAppLoader, hideAppLoader} from "app/Components/Shared/Loader/LoaderSlice";
const SelectSubscriber = ({ title, onSubmit, onSubscriberSelect, onOneSubscriberAction, onNoSubscriberAction, hideRadioButtons = true, submitButtonText = "המשך" }) => {
  const [subscriberList, setSubscriberList] = useState([]);
  const [selectedSubscriber, setSelectedSubscriber] = useState(null);
  const [error, setError] = useState(null);
  const [isButtonSticky, setIsButtonSticky] = useState(false);
  const containerRef = useRef(null);
  const dispatch = useDispatch();
  const selfcarePage = useSelector((state) => state.selfcarePage);

  useEffect(() => {
    if (selfcarePage?.isFetchLoginData && !subscriberList.length) {
      dispatch(showAppLoader());
      if (selfcarePage?.subscribersByProduct?.Cellular) {
        fetchSubscribers();
      } else {
        dispatch(Onboarding()).then(() => {
          fetchSubscribers();
        });
      }
      dispatch(hideAppLoader());
    }
  }, [selfcarePage?.isFetchLoginData, selfcarePage?.subscribersByProduct?.Cellular]);

  const handleSelectSubscriber = (subscriber) => {
    setSelectedSubscriber(subscriber);
    onSubscriberSelect && onSubscriberSelect(subscriber);
  };

  const fetchSubscribers = () => {
    try {
      const cellularSubscribers = selfcarePage?.subscribersByProduct?.Cellular?.map(({ productSubscriberNo, productFirstName, productLastName }) => ({
        subscriberNumber: productSubscriberNo,
        firstName: productFirstName,
        lastName: productLastName,
      })) || [];
      if (cellularSubscribers.length === 1 && onOneSubscriberAction) {
        const singleSubscriber = cellularSubscribers[0];
        handleSelectSubscriber(singleSubscriber.subscriberNumber.trim());
        onOneSubscriberAction(singleSubscriber.subscriberNumber.trim());
        return;
      }

      if (cellularSubscribers.length === 0) {
        onNoSubscriberAction && onNoSubscriberAction();
        setSubscriberList([]);
      } else {
        setSubscriberList(cellularSubscribers.map(({ subscriberNumber, firstName, lastName }) => ({
          value: subscriberNumber.trim(),
          key: `${subscriberNumber.trim()} ${firstName.trim()} ${lastName.trim()}`,
        })));
      }
    } catch (error) {
      console.error("Error fetching subscribers:", error);
      onNoSubscriberAction && onNoSubscriberAction();
      setSubscriberList([]);
    } finally {
      dispatch(hideAppLoader());
    }
  };

  const handleSubmit = () => {
    if (!selectedSubscriber) {
      setError("עליך לבחור מנוי כדי להמשיך");
    } else {
      onSubmit(selectedSubscriber);
    }
  };

  const renderConditionExist =() =>{
    return subscriberList.length > 1;
  }

  const checkIfButtonShouldBeSticky = () => {
    if (containerRef.current && subscriberList.length > 0) {
      const container = containerRef.current;
      const isOverflowing = container.scrollHeight > container.clientHeight;
      setIsButtonSticky(isOverflowing);
    }
  };

  useEffect(() => {
    checkIfButtonShouldBeSticky();
    // Add resize listener to recheck on window resize
    const handleResize = () => checkIfButtonShouldBeSticky();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [subscriberList]);

  if (!subscriberList.length) {
    return null;
  }

  return (
    renderConditionExist() &&
    <div className="select-subscriber-wrapper">
      <div className="select-subscriber-container" ref={containerRef}>
        <div className="title-container">
          <span className="title">{title}</span>
        </div>
        <SelectList
          options={subscriberList}
          onClick={handleSelectSubscriber}
          hideRadioButtons={hideRadioButtons}
        />
      </div>
      <div className={`bottom-container ${isButtonSticky ? 'sticky-bottom' : ''}`}>
        {error && <span className="error">{error}</span>}
        <BtnSubmit text={submitButtonText} onclick={handleSubmit} />
      </div>
    </div>
  );
};

export default SelectSubscriber;
